import styled from 'styled-components';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { END_CONSTANTS } from '../../../../constants/end';

export const EndPc = ({
  goOfflineTab,
  isEarlyEnd,
}: {
  goOfflineTab: () => void;
  isEarlyEnd: boolean;
}) => {
  const { getText } = useTextVariant(END_CONSTANTS, false);

  return (
    <>
      <EndContainer isEarlyEnd={isEarlyEnd}>
        {isEarlyEnd && <EarlyEnd>{getText('earlyEnd')}</EarlyEnd>}
        <EndText isEarlyEnd={isEarlyEnd}>{getText('endText')}</EndText>
        <Divider isEarlyEnd={isEarlyEnd} />
        <EndDesc>{getText('endDesc')}</EndDesc>
        <EndSubText>{getText('endSubText')}</EndSubText>
      </EndContainer>
      <BottomTabContainer onClick={goOfflineTab}>
        <GoTournamentBtn>{getText('btnText')}</GoTournamentBtn>
      </BottomTabContainer>
    </>
  );
};

const EarlyEnd = styled.h4`
  color: #ba8484;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 38px; /* 190% */
  letter-spacing: -0.4px;
`;

const EndSubText = styled.h4`
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.4px;
  padding-top: 10px;

  span {
    color: rgba(255, 241, 201, 0.8);
    text-decoration-line: underline;
  }
`;

const Divider = styled.div<{ isEarlyEnd: boolean }>`
  width: 349px;
  height: 1px;
  background-color: ${(props) => (props.isEarlyEnd ? 'rgba(255, 96, 98, 0.40)' : '#484343')};
  margin: 0 auto;
  margin-bottom: 28px;
`;

const EndText = styled.h3<{ isEarlyEnd?: boolean }>`
  color: ${(props) => (props.isEarlyEnd ? '#FF6062' : '#D3D3D3')};
  text-align: center;
  font-size: 25px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -1.5px;
  padding-bottom: 20px;
  margin-bottom: 10px;
`;

const EndDesc = styled.h4`
  white-space: pre-wrap;
  color: rgba(255, 255, 255, 0.45);
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.44px;
  margin-bottom: 30px;
`;

const EndContainer = styled.div<{ isEarlyEnd: boolean }>`
  flex: 1;
  padding-bottom: 100px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: ${(props) => (props.isEarlyEnd ? '65px' : '75px')};
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #262524;
  height: 96px;
`;

const GoTournamentBtn = styled.button`
  height: 70px;
  width: 442px;
  cursor: pointer;
  border-radius: 125px;
  background: rgba(139, 0, 67, 0.85);
  backdrop-filter: blur(25px);
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.96px;
`;
